// Vue
import Vue from 'vue';
// Imports
import BaseApp from './components/App';
import Footer from './components/modules/Footer';
import Navbar from './components/modules/Navbar';
import NewLink from './components/modules/NewLink';
import Sidebar from './components/modules/Sidebar';
import BrowsersGraph from './components/widgets/BrowsersGraph';

import ComentarioModulo from '@modules/Comentario/Resources/assets/js/Read';
import Anexos from '@modules/GerenciadorArquivo/Resources/assets/js/Anexo';
import Arvore from '@modules/GerenciadorArquivo/Resources/assets/js/includes/Arvore';
import ArvoreSubPastas from '@modules/GerenciadorArquivo/Resources/assets/js/includes/ArvoreSubPastas';
import GerenciadorArquivo from '@modules/GerenciadorArquivo/Resources/assets/js/Index';
import PrintFooter from './components/print/Footer';
import PrintHeader from './components/print/Header';
import Print from './components/print/Print';
import Calendar from './components/widgets/Calendar';
import ChatApp from './components/widgets/chat/ChatApp';
import Comentarios from './components/widgets/Comentarios';
import DevicesGraph from './components/widgets/DevicesGraph';
import EnderecoForm from './components/widgets/EnderecoForm';
import SearchTecnico from './components/widgets/SearchTecnico';
import HeaderFamilia from './components/widgets/HeaderFamilia';
import HeaderServicoIntervencao from './components/widgets/HeaderServicoIntervencao';
import HeaderUsuario from './components/widgets/HeaderUsuario';
import Load from './components/widgets/Load';
import LocationsGraph from './components/widgets/LocationsGraph';
import ModalExcluirFamilia from './components/widgets/ModalExcluirFamilia';
import ModalExcluirUsuario from './components/widgets/ModalExcluirUsuario';
import ModalRemanejarAtendimento from './components/widgets/ModalRemanejarAtendimento';
import ModalRemanejarPAF from './components/widgets/ModalRemanejarPAF';
import ModalSelectConta from './components/widgets/ModalSelectConta';
import ModalStatusHistorico from './components/widgets/ModalStatusHistorico';
import ModalTecnicoAccept from './components/widgets/ModalTecnicoAccept';
import PlatformsGraph from './components/widgets/PlatformsGraph';
import PostApp from './components/widgets/post/PostApp';
import ReferrersGraph from './components/widgets/ReferrersGraph';
import SidebarServico from './components/widgets/SidebarServico';
import Table from './components/widgets/table/Table';


import Input from './components/form/Input';
import InputButton from './components/form/InputButton';
import InputCalendar from './components/form/InputCalendar';
import InputCalendarRange from './components/form/InputCalendarRange';
import InputCheckbox from './components/form/InputCheckbox';
import InputMaster from './components/form/InputMaster';
import InputTag from './components/form/InputTag';
import Pagination from './components/form/Pagination';
import Password from './components/form/Password';
import Radio from './components/form/Radio';
import Select from './components/form/Select';
import SelectAutocomplete from './components/form/SelectAutocomplete';
import SelectGroup from './components/form/SelectGroup';
import SelectInput from './components/form/SelectInput';
import TextArea from './components/form/TextArea';
import TextAreaEditor from './components/form/TextAreaEditor';
import ToggleButton from './components/form/ToggleButton';
import ToggleButtonGroup from './components/form/ToggleButtonGroup';

import Stepper from "./components/form/Stepper.vue";

//Reports
//SCFV
import ModalBuscarFamilia from './components/widgets/ModalBuscarFamilia';
import ModalFormulario from './components/widgets/ModalFormulario';
import GruposGraph from './components/widgets/reports/scfv/GruposGraph';
import PrioritariasGraph from './components/widgets/reports/scfv/PrioritariasGraph';


import AreaGraph from './components/widgets/AreaGraph';
import BarGraph from './components/widgets/BarGraph';
import DonutGraph from './components/widgets/DonutGraph';

// import Multiselect from 'vue-multiselect'

import InputColor from './components/form/InputColor';
import InputFile from './components/form/InputFile';
import InputFileGroup from './components/form/InputFileGroup';
import InputGroup from './components/form/InputGroup';


import AlertIcon from './components/alerts/AlertIcon';
import Attachment from './components/elements/attachment';
import FilterGraficos from './components/elements/reports/FilterGraficos';
import LoadingReport from './components/elements/reports/LoadingReport';
import InputWysiwyg from './components/form/input-wysiwyg';

import LoadingInline from './components/elements/LoadingInline';

// Components
Vue.component('app', BaseApp);
Vue.component('navbar-module', Navbar);
Vue.component('sidebar-module', Sidebar);
Vue.component('footer-module', Footer);
Vue.component('new-link', NewLink);
Vue.component('status-historico', ModalStatusHistorico);
Vue.component('excluir-usuario', ModalExcluirUsuario);
Vue.component('excluir-familia', ModalExcluirFamilia);
Vue.component('remanejar-atendimento', ModalRemanejarAtendimento);
Vue.component('remanejar-acompanhamento', ModalRemanejarPAF);

Vue.component('stepper', Stepper);

// Widgets
Vue.component("header-servico", HeaderServicoIntervencao);
Vue.component("modal-formulario", ModalFormulario);
Vue.component("chat-app", ChatApp);
Vue.component("post-app", PostApp);
Vue.component('table-app', Table);
Vue.component('load', Load);
Vue.component('calendar-app', Calendar);
Vue.component('modulo-gerenciador-arquivo', GerenciadorArquivo);
Vue.component('arvore-subpasta', ArvoreSubPastas);
Vue.component('arvore', Arvore);
Vue.component('anexos', Anexos);
Vue.component('modulo-comentario', ComentarioModulo);
Vue.component('comentarios', Comentarios);
Vue.component('sidebar-servicos', SidebarServico);
Vue.component('header-familia', HeaderFamilia);
Vue.component('header-usuario', HeaderUsuario);
Vue.component('browsers-graph', BrowsersGraph);
Vue.component('modal-buscar-familia', ModalBuscarFamilia);
Vue.component('search-tecnico', SearchTecnico);
Vue.component('modal-tecnico-accept', ModalTecnicoAccept);

Vue.component('devices-graph', DevicesGraph);
Vue.component('locations-graph', LocationsGraph);
Vue.component('platforms-graph', PlatformsGraph);
Vue.component('referrers-graph', ReferrersGraph);
// From
Vue.component('form-input', Input);
Vue.component('form-input-button', InputButton);
Vue.component('form-checkbox', InputCheckbox);
Vue.component('form-input-master', InputMaster);
Vue.component('form-input-tag', InputTag);
Vue.component('form-Select-autocomplete', SelectAutocomplete);
Vue.component('form-input-color', InputColor);
Vue.component('form-calendar', InputCalendar);
Vue.component('form-calendar-range', InputCalendarRange);
Vue.component('form-password', Password);
Vue.component('form-select', Select);
Vue.component('form-select-input', SelectInput);
Vue.component('form-select-group', SelectGroup);
Vue.component('form-radio', Radio);
Vue.component('form-textarea', TextArea);
Vue.component('form-textarea-editor', TextAreaEditor);
Vue.component('form-toggle', ToggleButton);
Vue.component('form-toggle-group', ToggleButtonGroup);
Vue.component('form-endereco', EnderecoForm);
Vue.component('pagination', Pagination);


// Vue.component('multiselect', Multiselect)

Vue.component('form-input-group', InputGroup);
Vue.component('form-file-group', InputFileGroup);
Vue.component('form-file', InputFile);
Vue.component('modal-select-conta', ModalSelectConta);


Vue.component('print-header', PrintHeader);
Vue.component('print-footer', PrintFooter);
Vue.component('print-content', Print);

//Reports
//SCFV
Vue.component('grupos-graph', GruposGraph);
Vue.component('prioritarias-graph', PrioritariasGraph);
Vue.component('donut-graph', DonutGraph);
Vue.component('bar-graph', BarGraph);
Vue.component('area-graph', AreaGraph);


Vue.component('input-wysiwyg', InputWysiwyg);
Vue.component('attachment', Attachment);
Vue.component('filter-reports', FilterGraficos);
Vue.component('loading-report', LoadingReport);
Vue.component('alert-icon', AlertIcon);
Vue.component('load-inline', LoadingInline);



